export interface IEpiProps {
    shippingAddressLabel: string;
    selectAddressLabel: string;
    selectAddressPrompt: string;
    newAddressLabel: string;
    newAddressUrl: string;
    editLabel: string;
    cancelLabel: string;
    saveLabel: string;
}

export class EpiProps implements IEpiProps {
    shippingAddressLabel: string = '';
    selectAddressLabel: string = '';
    selectAddressPrompt: string = '';
    newAddressLabel: string = '';
    newAddressUrl: string = '';
    editLabel: string = '';
    cancelLabel: string = '';
    saveLabel: string = '';

}